<template>
    <div class="vue-image-slider">
        <template>
            <VueSlickCarousel v-bind="settings">
                <slot></slot>
            </VueSlickCarousel>
        </template>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: "ImageSlider",
    components: { VueSlickCarousel },

    data() {
        return {
            settings: {
                arrows: true,
                dots: true,
                lazyLoad: "ondemand",
                fade: true,
            }
        }
    }
}
</script>